module.exports = __webpack_public_path__ + "static/media/Test57.c1132fd1.bmp";